import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';
import { DataReq, ICloneMenu } from '@/services/CloneMenu/index';

export async function createMenuClone(payload: ICloneMenu.DataReq) {
  return axios.post(`${ip3}/menu-report`, payload);
}

export async function getCloneMenu(
  payload: {
    cond?: any;
  },
  loaiHinh?: string | 'Mầm non' | 'Nhà trẻ',
) {
  return axios.get(`${ip3}/menu-report/all`, {
    params: {
      ...payload,
      cond: {
        ...payload.cond,
        loaiHinhLop: loaiHinh,
      },
    },
  });
}

export async function getManyCloneMenu(
  payload: {
    startDate: any,
    endDate: any,
    cond: {
      loaiHinh: string,
      donViId: string
    }
  },
) {
  return axios.post(`${ip3}/menu-report/many/startDate/${payload.startDate}/endDate/${payload.endDate}`, null, {
    params: payload
  } );
}

export async function delCloneMenu(id: string) {
  return axios.delete(`${ip3}/menu-report/${id}`);
}

export async function getMenuTemplateClone(cond: any) {
  return axios.get(`${ip3}/menu-report/clone`, {
    params: {
      cond,
    },
  });
}

export async function exportData(payload: {
  donViId: string;
  loaiHinhLop: string;
  fromDate: string;
  toDate: string;
}) {
  return axios.get(`${ip3}/menu-report/export`, {
    params: payload,
    responseType: 'arraybuffer',
  });
}
export async function importData(payload: any) {
  const file = payload?.file?.fileList?.[0].originFileObj;
  const form = new FormData();
  form.append('file', file);
  // form.append('datatype', vaiTro === 'SuperAdmin' || vaiTro === 'Admin' ? 'Hệ thống' : 'Khác');
  return axios.post(`${ip3}/menu-report/import`, form, {
    params: {
      donViId: payload.donViId,
      loaiHinh: payload.loaiHinh,
    },
  });
}
